import React, { useState } from "react";
import { Outlet, NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const ManagerLayout = () => {
  const [isOpen, setIsOpen] = useState(true);
  const { user, logout } = useAuth();

  const menu = [
    { path: "/manager/dashboard", icon: "bi-speedometer2", label: "Dashboard" },
    {
      path: "/manager/grievances",
      icon: "bi-chat-left-text",
      label: "Grievances",
    },
  ];

  return (
    <div className="d-flex">
      {/* Sidebar */}
      <div
        style={{
          width: isOpen ? "220px" : "65px",
          minHeight: "100vh",
          background: "linear-gradient(180deg, #7b2d00 0%, #b45309 100%)",
          transition: "width 0.3s ease",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 1000,
          overflow: "hidden",
        }}
      >
        <div
          className="d-flex align-items-center p-3 border-bottom border-white border-opacity-25"
          style={{ minHeight: "64px" }}
        >
          <i className="bi bi-person-badge text-white fs-4 flex-shrink-0"></i>
          {isOpen && (
            <span className="text-white fw-bold ms-2 small text-nowrap">
              Manager Panel
            </span>
          )}
        </div>
        <nav className="py-2">
          {menu.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `d-flex align-items-center px-3 py-2 text-decoration-none mx-2 my-1 rounded-3 ${
                  isActive
                    ? "bg-white bg-opacity-25 text-white"
                    : "text-white text-opacity-75"
                }`
              }
              style={{ minHeight: "42px" }}
            >
              <i className={`bi ${item.icon} fs-5 flex-shrink-0`}></i>
              {isOpen && (
                <span className="ms-3 small fw-medium text-nowrap">
                  {item.label}
                </span>
              )}
            </NavLink>
          ))}
        </nav>
        <div className="p-2 border-top border-white border-opacity-25 position-absolute bottom-0 w-100">
          <button
            onClick={logout}
            className="btn d-flex align-items-center w-100 text-white text-opacity-75 px-3 py-2 rounded-3"
            style={{ background: "transparent" }}
          >
            <i className="bi bi-box-arrow-left fs-5"></i>
            {isOpen && <span className="ms-3 small fw-medium">Logout</span>}
          </button>
        </div>
      </div>

      {/* Main */}
      <div
        style={{
          marginLeft: isOpen ? "220px" : "65px",
          transition: "margin-left 0.3s ease",
          width: "100%",
          minHeight: "100vh",
          background: "#f5f6fa",
        }}
      >
        {/* Navbar */}
        <nav
          className="navbar bg-white border-bottom shadow-sm px-3"
          style={{
            position: "fixed",
            top: 0,
            left: isOpen ? "220px" : "65px",
            right: 0,
            height: "64px",
            zIndex: 999,
            transition: "left 0.3s ease",
          }}
        >
          <button
            className="btn btn-light btn-sm me-3"
            onClick={() => setIsOpen(!isOpen)}
          >
            <i className="bi bi-layout-sidebar fs-5"></i>
          </button>
          <span className="fw-semibold text-dark">Manager Panel</span>
          <div className="ms-auto d-flex align-items-center gap-2">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center text-white fw-bold"
              style={{
                width: 34,
                height: 34,
                background: "linear-gradient(135deg, #7b2d00, #b45309)",
                fontSize: "13px",
              }}
            >
              {user?.name?.charAt(0).toUpperCase()}
            </div>
            <span className="small fw-medium d-none d-md-inline">
              {user?.name}
            </span>
          </div>
        </nav>
        <div style={{ paddingTop: "64px" }}>
          <div className="p-4">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagerLayout;
